import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import API from '../../../create/api';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import { useStore } from 'react-redux';
import querystring from 'querystring';
import _ from 'lodash';
import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import * as helper from '../../../../helper/index';
import moment, { MomentInput } from 'moment-timezone';
import Button from '@mui/material/Button';
import { Box, Checkbox, LinearProgress, Pagination, TextField, Typography } from '@mui/material';
import MobileRow from './table.mobile.row';
import PaidIcon from '@mui/icons-material/Paid';
import Statuses from '../../../fields/status.rider';
import { useLocation } from 'react-router-dom';
import FilterControls from './_components/FilterControls';
import TableHeader from './_components/TableHeader';
import TableRows from './_components/TableRows';
import PaginationControls from './_components/PaginationControls';
import { ParcelStatus } from './types';
import SummarySection from './_components/SummarySection';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  fromControl: {
    width: '100%',
  },
  createButton: {
    paddingBottom: theme.spacing(2),
  },
  centerAlign: {
    textAlign: 'center',
    'span &': {
      verticalAlign: 'middle',
    },
  },
  onlyPrint: { display: 'none' },
  hidePrint: {},
  '@media print': {
    hidePrint: {
      display: 'none',
    },
    onlyPrint: { display: 'block' },
  },
}));

export default function SpanningTable() {
  const classes = useStyles();

  const store = useStore();
  // first fetch
  const [checkbox, setcheckbox]: [Record<string, boolean>, any] = useState({});
  const [rows, setRows]: [any[], any] = useState([]);
  const [summary, setSummary] = useState<Record<string, { count: number; amount: number | null }> | null>(null);

  // delete modal
  const [deleteID, setDeleteID] = useState(undefined);
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setDeleteID(undefined);
    setOpen(false);
  };

  async function deleteAPN() {
    if (deleteID) {
      await API.destroy(`${process.env.REACT_APP_API_SERVER}/parcels`, deleteID)
        .then((res) => {})
        .catch((error) => {
          helper.axiosErrorHandling(error);
        })
        .finally(() => {
          handleClose();
        });
    }
  }
  // delete modal end

  // table filter
  let [company, setCompany]: any = React.useState(store.getState().parcel?.last_company);

  let [rider, setRider] = useState('');
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialSearch = params.get('search') || '';
  const [get_search, set_search] = useState(initialSearch);
  const [getParcelDate, setParcelDate] = useState<{ start?: string; end?: string }>({});
  let [get_page_no, set_page_no] = useState(1);
  let [get_total_parcel_count, set_total_parcel_count] = useState(0);

  const initialLimit = localStorage.getItem('limitMerchant')
    ? JSON.parse(localStorage.getItem('limitMerchant') ?? '')
    : 500;
  const initialSortType = localStorage.getItem('sortMerchant')
    ? JSON.parse(localStorage.getItem('sortMerchant') ?? '')
    : 'id:ASC';
  const [limit, setLimit] = React.useState(initialLimit);
  const [sortBy, setSortBy] = useState(initialSortType);
  const [loading, setLoading] = useState(false);

  const parcelStatusOptions = store.getState().parcel?.parcelStatus || [];

  // Add a function to extract status from the URL
  const getStatusFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const statusInParams = params.getAll('status_in');

    if (statusInParams.length > 0) {
      return statusInParams;
    }
    return [];
  };

  // Add state to manage selected statuses
  const [get_status, set_status] = useState<any[]>(getStatusFromUrl());

  // Update the useEffect to handle URL changes
  useEffect(() => {
    set_status(getStatusFromUrl());
  }, [window.location.search]);

  // Update the useEffect to handle URL changes
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParam = params.get('search') || '';
    set_search(searchParam);
  }, [location.search]);

  async function getParcel({ search, company, area, status, rider, balance }: any) {
    setLoading(true);
    function date_filter() {
      if (getParcelDate.start && !getParcelDate.end) {
        return {
          booking_date_gte: moment(getParcelDate.start).format('YYYY-MM-DD'),
          booking_date_lt: moment(getParcelDate.start).add(1, 'd').format('YYYY-MM-DD'),
          _start: limit * (get_page_no - 1),
          _limit: limit,
        };
      }

      if (getParcelDate.start && getParcelDate.end) {
        const date_from = moment(getParcelDate.start as MomentInput).format('YYYY-MM-DD');
        const date_to = moment(getParcelDate.end as MomentInput)
          .add(1, 'd')
          .format('YYYY-MM-DD');

        return {
          booking_date_gte: date_from,
          booking_date_lt: date_to,
          _start: limit * (get_page_no - 1),
          _limit: limit,
        };
      }

      return {
        _start: limit * (get_page_no - 1),
        _limit: limit,
      };
    }

    const param = querystring.encode(
      _.pickBy(
        {
          _q: (search || '').trim(),
          company: company?.value,
          area: area?.value,
          status_in: get_status, // Use the status array from state
          rider: rider?.value,
          addToBalance: balance,
          _sort: sortBy,
          ...date_filter(),
        },
        _.identity,
      ),
    );

    const [getParcelData, parcel_count]: any[] = await Promise.all([
      API.getAll(`${process.env.REACT_APP_API_SERVER}/parcels?${param}`),
      API.count(`${process.env.REACT_APP_API_SERVER}/parcels/count?${param}`),
    ]);
    set_total_parcel_count(parcel_count);

    setSummary(getParcelData?.summary);
    const parcels = getParcelData?.parcels || [];
    const rows: any[] = [];
    let update = { ...checkbox };
    for (let i = 0; i < parcels.length; i++) {
      const parcel = parcels[i];
      parcel.checked = false;
      rows.push(parcel);
      update = { ...update, [`checkbox-${parcel.id}`]: false };
    }
    setRows(rows);
    setcheckbox(update);
    setLoading(false);
  }
  useEffect(() => {
    getParcel({ search: get_search, company, status: get_status, rider });
  }, [get_search, company, get_status, rider, getParcelDate, get_page_no, limit, sortBy]);

  // checkbox function
  // eslint-disable-next-line
  const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newRows = [...rows];
    const index = rows.findIndex((row) => String(row.id) === event.target.name?.split('-')?.[1]);
    if (index >= 0) {
      newRows[index].checked = event.target.checked;
    }

    setRows(newRows);
    setcheckbox({ ...checkbox, [event.target.name]: event.target.checked });
    if (newRows?.filter((r) => r.checked)?.length === rows.length) {
      setselectAll(true);
    } else {
      setselectAll(false);
    }
  };

  // eslint-disable-next-line
  let [selectAll, setselectAll]: [boolean, any] = useState(false);

  // check all parcel
  // eslint-disable-next-line
  const checkAllParcel = (event: React.ChangeEvent<HTMLInputElement>) => {
    let update = { ...checkbox };
    for (let i = 0; i < rows.length; i++) {
      rows[i].checked = event.target.checked;
      update = { ...update, [`checkbox-${rows[i].id}`]: event.target.checked };
    }
    setRows(rows);
    setcheckbox(update);
    if (rows?.filter((r) => r.checked)?.length === rows.length) {
      setselectAll(true);
    } else {
      setselectAll(false);
    }
  };
  // eslint-disable-next-line
  let [statusIDSetAction, setstatusIDSetAction]: [number | null, any] = useState(null);
  // eslint-disable-next-line
  async function updateCheckboxStatus() {
    for (let i = 0; i < Object.entries(checkbox).length; i++) {
      const [parcelID, value] = Object.entries(checkbox)[i];
      try {
        if (value && statusIDSetAction) {
          await axios.put(
            `${process.env.REACT_APP_API_SERVER}/parcels/${parcelID.split('-')[1]}`,
            {
              status: statusIDSetAction,
            },
            {
              headers: {
                Authorization: `Bearer ${store.getState().auth.jwt}`,
              },
            },
          );
          toastr.success(
            'Parcel Updated',
            `Parcel ID:${parcelID?.split('-')?.[1] ?? ''} Status to ${statusIDSetAction} updated`,
          );
        }
      } catch (error: any) {
        helper.axiosErrorHandling(error);
      }
    }
    getParcel({ company, status: get_status, rider });
  }

  return (
    <div>
      {loading && <LinearProgress />}
      <FilterControls
        get_search={get_search}
        set_search={set_search}
        getParcelDate={getParcelDate}
        setParcelDate={setParcelDate}
        get_status={get_status}
        set_status={set_status}
      />

      <div className="hidden md:block">
        {summary ? (
          <SummarySection summary={summary} />
        ) : (
          <div className="flex justify-between items-center px-4 py-2">
            <Typography sx={{ fontWeight: 'bold' }} variant="button">
              Total: {get_total_parcel_count}
            </Typography>
          </div>
        )}
        <TableContainer component={Paper}>
          <Modal
            aria-labelledby="spring-modal-title"
            aria-describedby="spring-modal-description"
            className={classes.modal}
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropProps={{
              timeout: 500,
            }}
          >
            <div className={classes.paper}>
              <h1 id="spring-modal-title">Delete</h1>
              <p id="spring-modal-description">
                Do you want to delete APN {deleteID}
                <br />
                <Button color="secondary" onClick={deleteAPN}>
                  Yes
                </Button>
                <Button color="primary" onClick={handleClose}>
                  No
                </Button>
              </p>
            </div>
          </Modal>

          <div className="flex w-full justify-between p-2">
            <PaginationControls
              get_total_parcel_count={get_total_parcel_count}
              limit={limit}
              setLimit={setLimit}
              sortBy={sortBy}
              setSortBy={setSortBy}
              get_page_no={get_page_no}
              set_page_no={set_page_no}
            />
          </div>
          <Table className={classes.table} aria-label="a dense table" padding="checkbox">
            <TableHeader selectAll={selectAll} checkAllParcel={checkAllParcel} />
            <TableRows rows={rows} checkbox={checkbox} handleCheckBox={handleCheckBox} />
          </Table>
        </TableContainer>
      </div>

      <div className="md:hidden">
        {summary ? (
          <SummarySection summary={summary} />
        ) : (
          <div className="flex justify-between items-center px-4 py-2">
            <Typography sx={{ fontWeight: 'bold' }} variant="button">
              Total: {get_total_parcel_count}
            </Typography>
          </div>
        )}
        <div className="flex w-full justify-between p-2">
          <PaginationControls
            get_total_parcel_count={get_total_parcel_count}
            limit={limit}
            setLimit={setLimit}
            sortBy={sortBy}
            setSortBy={setSortBy}
            get_page_no={get_page_no}
            set_page_no={set_page_no}
          />
        </div>
        {rows.map((row) => (
          <MobileRow key={row.id} row={row} />
        ))}
      </div>
    </div>
  );
}
